import React, { useState, useEffect } from "react";
import MultiAction from "../../../../components/MultiAction";
import CandidateDetailsModal from "../../../../components/CandidateDetailsModal";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants/index";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller,PostFormServiceCaller } from "../../../../services/serviceCaller";
import { Users } from "lucide-react";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


function PostJob() {
  const TA_HEAD_ROLEID = 56;
  const loggedInUser = JSON.parse(localStorage.getItem("user")) || {};
  const isTaHead = Array.isArray(loggedInUser.roles) && loggedInUser.roles.some(role => Number(role.RoleID) === TA_HEAD_ROLEID);

  const navigate = useNavigate();

  const [postJob, setPostJob] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [clickedId, setClickedId] = useState("");
  const [isRmgLeadsClick, setIsRmgLeadsClick] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [isPostJobLoading, setIsPostJobLoading] = useState(true);
  const [apiStatus, setApiStatus] = useState(undefined);

  // --- MODAL DIALOG STATES ---
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [showRecallModal, setShowRecallModal] = useState(false);
  const [pendingRecallRecord, setPendingRecallRecord] = useState(null);
  const [recallRemarks, setRecallRemarks] = useState("");

  // --- ASSIGN DIALOG STATES ---
  const [requirementDetails, setRequirementDetails] = useState(null);
  const [allocatedDate, setAllocatedDate] = useState("");
  const [isAssignOpen, setIsAssignOpen] = useState(false);
  const [isJDExpanded, setIsJDExpanded] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [targetJobId, setTargetJobId] = useState(""); 
  const [ta1Error, setTa1Error] = useState(false); 
  
  const [prtList, setPrtList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAssignLoading, setIsAssignLoading] = useState(false);
  // ------------------------------------

  // --- DYNAMIC INLINE CSS GENERATOR ---
  // Calculates 1-based index table row offsets to fade out bad records natively
  const disabledRowIndexes = postJob
    .map((item, index) => (!item.RequisitionID ? index + 1 : null))
    .filter((index) => index !== null);

  const fetchPostaJob = async (id, isRmgLeads = false, isSilent = false) => {
    if (!id) {
      if (!isSilent) {
        setIsPostJobLoading(true);
        setApiStatus(undefined);
      }
    } else {
      setModalLoading(true);
      setModalData([]);
    }
    try {
      let apiUrl = `${API_URL}JobDescriptions?jobDescriptionid=${id}`;
      if (isRmgLeads && id) {
        apiUrl += `&isRmgLeads=1`;
      }
      const response = await GetServiceCaller(apiUrl);
      if (!id) {
        setApiStatus(response?.status);
      }
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.data || [];
        console.log("cleanedData", cleanedData);
      
        const loggedInUser = JSON.parse(localStorage.getItem("user"));
        const contactId = loggedInUser?.DefaultContactID;

        const processedData = cleanedData.map((item) => {
          const isJobInactive = (item.RecallRemarks && item.RecallRemarks.trim() !== "") || (item.RecallRemarksRMG && item.RecallRemarksRMG.trim() !== "") || item.isClosed === 1 || item.isClosed === true ? 1 : 0;
          return {
            ...item,
            isJobInactive,
            isNewApplication: !item.RequisitionID 
              ? true 
              : (Number(item.PrimaryHRID) === Number(contactId) || Number(item.SecondaryHRID) === Number(contactId)),
            isAssignDisabled: !item.RequisitionID,
            RecallRemarks: item.RecallRemarks || "",
            CreatedByName: item.CreatedByName ? (
              <span title={item.CreatedByName}>{item.CreatedByName}</span>
            ) : "",
            ModifiedByName: item.ModifiedByName ? (
              <span title={item.ModifiedByName}>{item.ModifiedByName}</span>
            ) : "",
            PrimaryHRName: item.PrimaryHRName ? (
              <span title={item.PrimaryHRName}>{item.PrimaryHRName}</span>
            ) : "",
            SecondaryHRName: item.SecondaryHRName ? (
              <span title={item.SecondaryHRName}>{item.SecondaryHRName}</span>
            ) : "",
            RequisitionID: item.RequisitionID ? (
              <span 
                data-job-inactive={isJobInactive} 
                data-has-req-id="1" 
                data-has-details-pending={item.RecallRemarksTA && item.RecallRemarksTA.trim() !== "" ? "1" : "0"}
              >
                {item.RequisitionID}
              </span>
            ) : (
              <span 
                data-job-inactive={isJobInactive} 
                data-has-req-id="0" 
                data-has-details-pending={item.RecallRemarksTA && item.RecallRemarksTA.trim() !== "" ? "1" : "0"}
              ></span>
            ),
            RmgLeadsCount: (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  openRmgLeadsModal(item);
                }}
                style={{ cursor: "pointer" }}
              >
                {item.RmgLeadsCount || 0}
              </span>
            ),
            TitleWithJobCode: (
              <span
                data-job-inactive={isJobInactive}
                onClick={() => {
                  const titleStr = item.Title ? item.Title.split(' [')[0] : (item.TitleWithJobCode ? item.TitleWithJobCode.split(' [')[0] : '');
                  navigate('/candidate-in-process', { state: { jobTitleFilter: item.ID, text: titleStr } });
                }}
                style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                title={item.Title ? item.Title.split(' [')[0] : (item.TitleWithJobCode ? item.TitleWithJobCode.split(' [')[0] : '')}
              >
                {item.Title ? item.Title.split(' [')[0] : (item.TitleWithJobCode ? item.TitleWithJobCode.split(' [')[0] : '')}
              </span>
            )
          };
        });

        // Only update the page table data on initial load (no id) to avoid full re-render when opening modal
        if (!id) {
          setPostJob(processedData);
        } else {
          const modalData = response?.data?.data?.jobdescriptionlist;
          setModalData(modalData);
        }
      } else {
        console.error(
          "Failed to fetch skills. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    } finally {
      if (id) {
        setModalLoading(false);
      }
      setIsPostJobLoading(false);
    }
  };

  const fetchPrtList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}get-ta-listing-details`);
      if (response && response.status === 200) {
        const listData = response?.data?.data || response?.data || [];
        setPrtList(listData);
      } else {
        console.error("Failed to fetch TA Lising:", response?.status);
      }
    } catch (error) {
      console.error("Error fetching TA Lising:", error);
    }
  };

  useEffect(() => {
    fetchPostaJob("");
    fetchPrtList();
  }, []);

  useEffect(() => {
    if (clickedId) {
      fetchPostaJob(clickedId, isRmgLeadsClick);
    }
  }, [clickedId]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Open Job"));
  }, []);

  useEffect(() => {
    const allColClasses = [
      "col-jobtitle", "col-requisition", "col-jobcode", "col-activedate",
      "col-targetdate", "col-primaryta", "col-secondaryta", "col-leads",
      "col-active", "col-ta", "col-remarks", "col-action", "col-pos"
    ];

    const applyTableStyles = () => {
      const rows = document.querySelectorAll("#skill-table-area table tbody tr");

      rows.forEach(row => {
        const inactiveSpan = row.querySelector("span[data-job-inactive='1']");
        const actionCell = row.querySelector(".col-action");
        if (inactiveSpan && actionCell) {
          actionCell.style.opacity = "0.5";
          actionCell.style.pointerEvents = "none";
        } else if (actionCell) {
          actionCell.style.opacity = "";
          actionCell.style.pointerEvents = "";
        }

        // Hide Assign and Refer Back icons for rows without a Requisition ID
        const hasNoReqId = row.querySelector("span[data-has-req-id='0']");
        const assignIcon = row.querySelector('.bi-person-plus');
        const recallIcon = row.querySelector('.bi-reply');
        
        if (assignIcon) {
          const assignContainer = assignIcon.closest('.me-2') || assignIcon.parentElement;
          if (assignContainer) {
            assignContainer.style.display = hasNoReqId ? 'none' : '';
          }
        }
        const hasDetailsPending = row.querySelector("span[data-has-details-pending='1']");
        if (recallIcon) {
          const recallContainer = recallIcon.closest('.me-2') || recallIcon.parentElement;
          if (recallContainer) {
            if (hasNoReqId) {
              recallContainer.style.display = 'none';
            } else if (hasDetailsPending) {
              recallContainer.style.display = '';
              recallIcon.style.opacity = '0.3';
              recallIcon.style.pointerEvents = 'none';
              recallIcon.style.cursor = 'not-allowed';
            } else {
              recallContainer.style.display = '';
              recallIcon.style.opacity = '';
              recallIcon.style.pointerEvents = '';
              recallIcon.style.cursor = '';
            }
          }
        }
      });

      const table = document.querySelector("#skill-table-area table");
      if (table) {
        // Clear all old column classes first to support dynamic updates
        table.querySelectorAll("thead th, tbody tr td").forEach(el => {
          allColClasses.forEach(cls => el.classList.remove(cls));
        });

        const headers = table.querySelectorAll("thead th");
        headers.forEach((th, index) => {
          const text = th.textContent.toLowerCase().trim();
          let colClass = "";
          if (text.includes("jobtitle")) colClass = "col-jobtitle";
          else if (text.includes("requisition id")) colClass = "col-requisition";
          else if (text.includes("jobcode")) colClass = "col-jobcode";
          else if (text.includes("pos")) colClass = "col-pos";
          else if (text.includes("active date")) colClass = "col-activedate";
          else if (text.includes("target date")) colClass = "col-targetdate";
          else if (text.includes("rmg leads")) colClass = "col-rmgleads";
          else if (text.includes("primary ta")) colClass = "col-primaryta";
          else if (text.includes("secondary ta")) colClass = "col-secondaryta";
          else if (text.includes("leads")) colClass = "col-leads";
          else if (text.includes("active")) colClass = "col-active";
          else if (text.includes("ta")) colClass = "col-ta";
          else if (text.includes("remarks")) colClass = "col-remarks";
          else if (text.includes("action")) colClass = "col-action";

          if (colClass) {
            th.classList.add(colClass);
            const cells = table.querySelectorAll(`tbody tr td:nth-child(${index + 1})`);
            cells.forEach(td => {
              td.classList.add(colClass);
            });
          }
        });
      }
    };
    // Execute immediately on render
    applyTableStyles();

    // Setup periodic observation interval
    const timer = setInterval(applyTableStyles, 500);
    return () => clearInterval(timer);
  }, []);

  const columns = {
    TitleWithJobCode: { text: "JobTitle" },
    RequisitionID: { text: "Requisition ID" },
    JobCode: { text: "JobCode" },
    NoOfPosition: { text: "# Pos" },
    ActiveDate: { text: "Active Date" },
    TargetDate: { text: "Target Date" },
    CreatedByName: { text: "Created By" },
    ModifiedByName: { text: "Modified By" },
    LeadCount: { text: "# Leads" },
    RmgLeadsCount: { text: "RMG Leads" },
    IsInActive: { text: "Active" },
    PrimaryHRName: { text: "Primary TA" },
    SecondaryHRName: { text: "Secondary TA" },
    RecallRemarks: { text: "RMG Remarks" },
  };

  const defaultColumns = {
    TitleWithJobCode: true,
    RequisitionID: true,
    JobCode:false,
    NoOfPosition: false,
    ActiveDate: true,
    TargetDate: true,
    CreatedByName: true,
    ModifiedByName: true,
    LeadCount: true,
    RmgLeadsCount: false, 
    IsInActive: true,
    PrimaryHRName: true,
    SecondaryHRName: true,
    RecallRemarks: false,
  };
  const handleEdit = (url, id) => {
    navigate(`/postjob/Edit/${id}`);
  };
  const newapplicationpage = (id) => {

    const selectedJob = postJob.find((item) => item.ID === id);

    if (!selectedJob?.isNewApplication) {
      console.log("Navigation blocked");
      return;
    }

    navigate(`/postjob/new-application${id}`);
  };
  const openRmgLeadsModal = (item) => {
    const selectedItem = typeof item === 'object' ? item : postJob.find(j => j.ID === item);
    setModalContent(selectedItem);
    setShowModal(true);
    setModalLoading(true);
    setIsRmgLeadsClick(true);
    setClickedId("");
    setTimeout(() => setClickedId(item.ID || item), 0);
  };

  const handleShowModalInParent = (item, id) => {
    const currentEvent = window.event;
    if (currentEvent && currentEvent.target) {
      const cell = currentEvent.target.closest("td");
      if (cell) {
        const table = cell.closest("table");
        if (table) {
          const ths = Array.from(table.querySelectorAll("thead th"));
          const index = cell.cellIndex;
          const headerText = ths[index]?.innerText || "";
          if (headerText.includes("RMG Leads")) {
            openRmgLeadsModal(item);
            return;
          }
        }
      }
    }

    const targetId = id !== undefined ? id : (item?.ID || item);
    const selectedItem = typeof item === 'object' ? item : postJob.find(j => j.ID === targetId);
    setModalContent(selectedItem);
    setShowModal(true);
    setModalLoading(true);
    setIsRmgLeadsClick(false);
    // Reset then set clickedId so useEffect fires even when re-clicking the same job
    setClickedId("");
    setTimeout(() => setClickedId(targetId), 0);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const todayDate = new Date().toISOString().split("T")[0];
  const formattedAllocationDate = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');

  const handleAssignClick = async (rowData) => {
    if (!isTaHead) {
      console.warn("Blocked: User does not have TA Head permission.");
      return;
    }

    if (rowData && typeof rowData === 'object' && rowData.isAssignDisabled) {
      console.warn("Blocked: RequisitionID is null.");
      return; 
    }

    console.log("API DATA", requirementDetails);

    const recordId = rowData && typeof rowData === 'object'
      ? (rowData.id || rowData.ID)
      : rowData;

    setIsAssignLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}job-requirement-details/${recordId}`
      );

      console.log("Requirement Details", response?.data);

      if (response?.status === 200) {
        setRequirementDetails(response?.data?.data || response?.data);
      }
    } catch (error) {
      console.error("Error fetching requirement details:", error);
    } finally {
      setIsAssignLoading(false);
    }

    setTargetJobId(recordId);
    setIsAssignOpen(true);
    setTa1Error(false);

    const prevPrimaryVal = rowData?.PrimaryHRID ? Number(rowData.PrimaryHRID) : null;
    const prevSecondaryVal = rowData?.SecondaryHRID ? Number(rowData.SecondaryHRID) : null;

    const matchedPrimary = selectOptions.find(opt => Number(opt.value) === prevPrimaryVal) || null;
    const matchedSecondary = selectOptions.find(opt => Number(opt.value) === prevSecondaryVal) || null;

    setSelectedAssignee(matchedPrimary);
    setSelectedRole(matchedSecondary);
  };

  const handleAssignSubmit = async (e) => {
    e.preventDefault();
    if (!selectedAssignee || !selectedAssignee.value) {
      setTa1Error(true);
      return;
    }
    setIsSubmitting(true);
    const payload = {
      PrimaryHRID: selectedAssignee?.value || null,
      SecondaryHRID: selectedRole?.value || null,
      AllocationDate: todayDate,
    };

    try {
      console.log('targetid', targetJobId);
      const response = await PostFormServiceCaller(
        `${API_URL}update-hr-requisition-details/${targetJobId}`, 
        payload,
        "put"
      );

      if (response && (response.status === 200 || response.status === 204)) {
        setIsAssignOpen(false);
        fetchPostaJob(""); 
      } else {
        console.error("Failed to update allocation details. Status:", response?.status);
      }
    } catch (error) {
      console.error("Error updating allocation details:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRecallClick = (record) => {
    if (record.isClosed === 1) {
      toast.error("Requisition is already fulfilled, can't request details.");
      return;
    }
    if (record.isCandidateOnboarded === 1 || record.isCandidateOnboarded === true) {
      toast.error("Candidate already onboarded, can't request details.");
      return;
    }
    if (record.RecallRemarksTA && record.RecallRemarksTA.trim() !== "") {
      toast.error("Request for details already sent. Awaiting RMG response.");
      return;
    }
    setPendingRecallRecord(record);
    setRecallRemarks("");
    setShowRecallModal(true);
  };

  const handleRecallSubmit = async (e) => {
    e.preventDefault();
    if (!recallRemarks || recallRemarks.trim() === "") {
      toast.error("Remarks is mandatory");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await PostFormServiceCaller(
        `${API_URL}requisition/recall`,
        {
          id: pendingRecallRecord.ID,
          remarks: recallRemarks
        },
        "post"
      );

      if (response && response.status === 200) {
        toast.success("Request for details sent successfully");
        setShowRecallModal(false);
        setPendingRecallRecord(null);
        fetchPostaJob("");
      } else {
        toast.error("Failed to send request for details");
      }
    } catch (error) {
      console.error("Error sending request for details:", error);
      toast.error("Error sending request for details");
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectOptions = prtList.map((item) => ({
    value: item.ID,
    label: item.Name,
  }));

  const compactSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '32px',
      height: '32px',
      fontSize: '12px',
      borderRadius: '0.375rem',
      borderColor: '#dee2e6',
    }),
    valueContainer: (base) => ({
      ...base,
      height: '32px',
      padding: '0 8px',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '32px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '2px 6px',
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '2px 6px',
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px',
      padding: '6px 10px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '12px',
    }),
  };

  return (
    <>
      {/* --- INLINE GLOBAL SELECTOR INJECTION --- */}
      <style>
        {`
          .truncate-text {
            flex-grow: 1;
            text-align: right;
            margin-left: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          #skill-table-area .table-responsive {
            overflow-x: auto !important;
            width: 100% !important;
            position: relative !important;
          }
          #skill-table-area .table-responsive > div.d-flex {
            position: sticky !important;
            left: 0 !important;
            width: 100% !important;
            background: #fff !important;
            padding-top: 10px !important;
            margin-bottom: 0 !important;
            z-index: 10 !important;
          }
          #skill-table-area table {
            table-layout: auto !important;
            width: 100% !important;
            min-width: 100% !important;
          }
          #skill-table-area table th,
          #skill-table-area table td {
            vertical-align: middle !important;
            padding: 10px 8px !important;
            line-height: 1.3 !important;
          }
          #skill-table-area table th {
            font-weight: 600 !important;
            white-space: nowrap !important;
          }
          #skill-table-area table th > span {
            display: inline-flex !important;
            align-items: center !important;
            vertical-align: middle !important;
          }
          
          /* Fluid widths for stretching, clamped by smaller pixel min-widths to avoid default view scrolling */
          .col-jobtitle {
            width: 24% !important;
            min-width: 150px !important;
          }
          .col-requisition {
            width: 10% !important;
            min-width: 90px !important;
            white-space: nowrap !important;
          }
          .col-jobcode {
            width: 9% !important;
            min-width: 80px !important;
            white-space: nowrap !important;
          }
          .col-activedate {
            width: 9% !important;
            min-width: 80px !important;
            white-space: nowrap !important;
          }
          .col-targetdate {
            width: 9% !important;
            min-width: 80px !important;
            white-space: nowrap !important;
          }
          .col-ta {
            width: 10% !important;
            min-width: 100px !important;
          }
          .col-leads {
            width: 7% !important;
            min-width: 60px !important;
            white-space: nowrap !important;
          }
          .col-active {
            width: 7% !important;
            min-width: 60px !important;
            white-space: nowrap !important;
          }
          .col-primaryta {
            width: 10% !important;
            min-width: 100px !important;
          }
          .col-secondaryta {
            width: 10% !important;
            min-width: 100px !important;
          }
          .col-action {
            width: 8% !important;
            min-width: 80px !important;
            text-align: center !important;
            white-space: nowrap !important;
          }
          .col-remarks {
            width: 12% !important;
            min-width: 120px !important;
          }
          .col-pos {
            width: 7% !important;
            min-width: 60px !important;
          }
          
          /* Single-line ellipsis truncation with native tooltip on hover */
          .col-jobtitle span,
          .col-ta span,
          .col-primaryta span,
          .col-secondaryta span,
          .col-remarks span {
            display: block !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            max-width: 100% !important;
            line-height: 1.3 !important;
          }
          
          /* Requisition closed - a candidate has been onboarded */
          .table tbody tr.row-onboarded > td {
            background-color: #d1e7dd !important;
          }
          .table tbody tr.row-onboarded:hover > td {
            background-color: #bcd8c9 !important;
          }
          .onboarded-legend {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 0.85rem;
            color: #495057;
          }
          .onboarded-legend-swatch {
            display: inline-block;
            width: 14px;
            height: 14px;
            border-radius: 3px;
            background-color: #d1e7dd;
            border: 1px solid #a3cfbb;
          }

          /* Automatically builds rule paths to pinpoint the 4th icon on invalid records */
          ${disabledRowIndexes.map(rowIndex => `
            .table tbody tr:nth-child(${rowIndex}) i.bi-person-plus {
              opacity: 0.25 !important;
              color: #a0a0a0 !important;
              pointer-events: none !important;
              cursor: not-allowed !important;
            }
          `).join('\n')}
        `}
      </style>

      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <div className="col-12 mb-2">
              <span className="onboarded-legend">
                <span className="onboarded-legend-swatch"></span>
                Rows shown in green mean the requisition is closed.
              </span>
            </div>
            <MultiAction
              data={postJob}
              rowClassName={(row) =>
                row?.isCandidateOnboarded === 1 ||
                row?.isCandidateOnboarded === true ||
                row?.isClosed === 1 ||
                row?.isClosed === true
                  ? "row-onboarded"
                  : undefined
              }
              modalData={modalData}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              showIcon4={isTaHead}
              showIcon5={isTaHead}
              handleIcon1={handleEdit}
              handleIcon2={newapplicationpage}
              handleIcon4={handleAssignClick}
              handleIcon5={handleRecallClick}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                Icon2: <i className="bi bi-file-earmark-plus icons"></i>,
                Icon4: <i className="bi bi-person-plus icons"></i>,
                Icon5: (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Request for Details</Tooltip>}
                  >
                    <i className="bi bi-reply icons"></i>
                  </OverlayTrigger>
                ),
              }}
              addNewPath="/postjob/add"
              handleShowModalInParent={handleShowModalInParent}
            />
            <CandidateDetailsModal
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              modalData={modalData}
              modalContent={modalContent}
              modalLoading={modalLoading}
              isRmgLead={isRmgLeadsClick}
              refreshData={() => {
                fetchPostaJob("", false, true);
                if (clickedId) {
                  fetchPostaJob(clickedId, isRmgLeadsClick);
                }
              }}
            />
          </div>
        </div>
      </div>

      {/* --- ASSIGN DIALOG BOX --- */}
      {isAssignOpen && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: "900px" }}>
            <div className="modal-content shadow-lg border-0 rounded-3">

              {/* Header */}
              <div className="modal-header bg-light border-bottom-0 py-2.5 px-4">
                <h5 className="modal-title fw-bold text-dark fs-6">
                  <i className="bi bi-people-fill me-2 text-success"></i>
                  Allocate TA
                </h5>

                <button
                  type="button"
                  className="btn btn-close shadow-none"
                  onClick={() => setIsAssignOpen(false)}
                />
              </div>

              <form onSubmit={handleAssignSubmit}>
                <div className="modal-body p-3">

                  {/* Requirements Details */}
                  <div className="mb-3 p-3 bg-light rounded-3 border">
                    <h6 className="fw-bold text-dark mb-2 pb-2 border-bottom small d-flex align-items-center">
                      <i className="bi bi-info-circle-fill me-2 text-primary"></i>
                      Requirements Details
                    </h6>

                    <div style={{ maxHeight: "280px", overflowY: "auto", paddingRight: "4px" }}>
                      <div className="row g-2">

                        {/* Helper function / JSX for clean key-value card */}
                        {[
                          { label: "Job Title", val: requirementDetails?.job_description?.Title },
                          { label: "Req ID", val: requirementDetails?.requirement_trackers?.RequisitionID },
                          { label: "Client", val: requirementDetails?.client_name },
                          { label: "Account Manager", val: requirementDetails?.account_manager_name },

                          { label: "RMG POC", val: requirementDetails?.rmg_poc_name },
                          { label: "Int 1", val: requirementDetails?.int1_name },
                          { label: "Int 2", val: requirementDetails?.int2_name },
                          { label: "Band", val: requirementDetails?.band_name },

                          { label: "Client Priority", val: requirementDetails?.client_priority_name },
                          { label: "Min Budget", val: requirementDetails?.min_budget },
                          { label: "Max Budget", val: requirementDetails?.max_budget },
                          { label: "Skills", val: requirementDetails?.skill_name },

                          { label: "Sub Skills", val: requirementDetails?.sub_skill_names },
                          { label: "Total Exp", val: requirementDetails?.job_description?.MaxExperience ? (String(requirementDetails.job_description.MaxExperience).toLowerCase().includes("year") ? requirementDetails.job_description.MaxExperience : `${requirementDetails.job_description.MaxExperience} Years`) : null },
                          { label: "Relevant Exp", val: requirementDetails?.job_description?.MinExperience ? (String(requirementDetails.job_description.MinExperience).toLowerCase().includes("year") ? requirementDetails.job_description.MinExperience : `${requirementDetails.job_description.MinExperience} Years`) : null },
                          { label: "Location", val: requirementDetails?.location_name },
                          { label: "Location Type", val: requirementDetails?.location_type || requirementDetails?.location_type_name },

                          { label: "Region", val: requirementDetails?.region_name },
                          { label: "Track", val: requirementDetails?.track_name },
                          { label: "Hiring Type", val: requirementDetails?.hiring_type_name },
                          { label: "Engagement Type", val: requirementDetails?.engagement_type_name },

                          { label: "Requirement Type", val: requirementDetails?.requirement_type_name },
                          { label: "Opening Type", val: requirementDetails?.opening_type_name },
                          { label: "Job Family", val: requirementDetails?.job_family_name },
                          { label: "Personal Area", val: requirementDetails?.personal_area_name },

                          { label: "Employee Group", val: requirementDetails?.employee_group_name },
                          { label: "Billing Type", val: requirementDetails?.billing_type_name },
                          { label: "Revenue", val: requirementDetails?.revenue },
                          { label: "Client Interview", val: requirementDetails?.client_interview == 1 ? "Yes" : (requirementDetails?.client_interview == 0 ? "No" : null) },

                          { label: "Project Type", val: requirementDetails?.project_type_name },
                          { label: "Opening Date", val: requirementDetails?.requirement_date },
                          { label: "Billing Date", val: requirementDetails?.billing_date },
                        ].map((item, idx) => (
                          <div key={idx} className="col-md-3 col-sm-6">
                            <div className="bg-white p-2 px-3 rounded-2 border border-light-subtle shadow-sm h-100 d-flex align-items-center overflow-hidden">
                              <span className="text-secondary small me-1 text-nowrap" style={{ fontSize: '12px' }}>
                                {item.label}:
                              </span>
                              <span className="text-dark text-truncate small ms-1" style={{ fontSize: '12.5px' }} title={item.val || "-"}>
                                {item.val || "-"}
                              </span>
                            </div>
                          </div>
                        ))}

                        {/* Job Description Card */}
                        <div className="col-md-3 col-sm-6">
                          <div className="bg-white p-2 px-3 rounded-2 border border-light-subtle shadow-sm h-100 d-flex align-items-center overflow-hidden">
                            <span className="text-secondary small me-2 text-nowrap" style={{ fontSize: '12px' }}>
                              Job Description:
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-light border text-secondary py-0 px-2 rounded-pill flex-shrink-0 shadow-none"
                              style={{ fontSize: '11px' }}
                              onClick={() => setIsJDExpanded(!isJDExpanded)}
                            >
                              <i className="bi bi-eye me-1 text-primary"></i> {isJDExpanded ? "Hide" : "View"}
                            </button>
                          </div>
                        </div>

                      </div>

                      {isJDExpanded && (
                        <div className="col-12 mt-2">
                          <div className="bg-white p-3 rounded shadow-sm border" style={{ maxHeight: "180px", overflowY: "auto" }}>
                            <h6 className="fw-bold text-dark border-bottom pb-1 mb-1" style={{ fontSize: "12px" }}>
                              <i className="bi bi-card-text me-2 text-primary"></i>
                              Full Job Description
                            </h6>
                            <div className="small text-dark" style={{ fontSize: "12px" }} dangerouslySetInnerHTML={{ __html: requirementDetails?.job_description?.Description || "No Description Available" }} />
                          </div>
                        </div>
                      )}
                    </div>

                  </div>

                    {/* Allocation Details */}
                  <h6 className="fw-bold text-dark mb-1.5 small" style={{ fontSize: '12px' }}>
                    <i className="bi bi-pencil-square me-1 text-success"></i>
                    Allocation Details
                  </h6>

                  <div className="row gx-3 gy-1">

                    <div className="col-md-4">
                      <label className="form-label text-secondary small mb-1" style={{ fontSize: '11.5px', fontWeight: '500' }}>
                        Allocate TA1 <span className="text-danger">*</span>
                      </label>

                       <Select
                        options={selectOptions}
                        value={selectedAssignee}
                        styles={compactSelectStyles}
                        onChange={(selectedOption) => {
                          setSelectedAssignee(selectedOption);
                          if (selectedOption && selectedOption.value) {
                            setTa1Error(false);
                          }
                        }}
                        placeholder="Search TA..."
                        isSearchable
                        isClearable
                      />
                      {ta1Error && (
                        <div className="text-danger small mt-1" style={{ fontSize: '11px' }}>
                          Please select TA1
                        </div>
                      )}
                    </div>

                    <div className="col-md-4">
                      <label className="form-label text-secondary small mb-1" style={{ fontSize: '11.5px', fontWeight: '500' }}>
                        Allocate TA2
                      </label>

                      <Select
                        options={selectOptions}
                        value={selectedRole}
                        styles={compactSelectStyles}
                        onChange={setSelectedRole}
                        placeholder="Search TA..."
                        isSearchable
                        isClearable
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label text-secondary small mb-1" style={{ fontSize: '11.5px', fontWeight: '500' }}>
                        Allocation Date <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        style={{ height: '32px', fontSize: '12px' }}
                        value={formattedAllocationDate}
                        readOnly
                      />
                    </div>

                  </div>

                </div>

                <div className="modal-footer border-top-0 bg-light py-1.5 px-3">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm rounded-pill"
                    style={{ fontSize: '12px', padding: '3px 16px' }}
                    onClick={() => setIsAssignOpen(false)}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-success btn-sm rounded-pill text-white d-inline-flex align-items-center"
                    style={{ fontSize: '12px', padding: '3px 16px' }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      
      {/* --- RECALL DIALOG BOX --- */}
      {showRecallModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(1px)' }} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '450px' }}>
            <div className="modal-content shadow-lg border-0 rounded-3">
              
              {/* Modal Header */}
              <div className="modal-header border-bottom-0 pt-4 px-4 pb-2">
                <div className="d-flex align-items-center gap-2">
                  <div className="bg-danger bg-opacity-10 p-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '38px', height: '38px' }}>
                    <i className="bi bi-exclamation-circle-fill text-danger fs-5"></i>
                  </div>
                  <h5 className="modal-title fw-bold text-dark fs-5">Request for Details</h5>
                </div>
                <button type="button" className="btn-close shadow-none ms-auto" onClick={() => { setShowRecallModal(false); setPendingRecallRecord(null); }}></button>
              </div>

              {/* Modal Body */}
              <form onSubmit={handleRecallSubmit}>
                <div className="modal-body px-4 py-3">
                  <p className="text-secondary mb-1" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                    Are you sure you want to request details for this Requisition?
                  </p>
                  
                  {pendingRecallRecord && (
                    <>
                      <div className="mt-2 p-2 bg-light rounded border text-muted small text-truncate">
                        <strong>Requisition ID:</strong> {pendingRecallRecord.RequisitionID || "N/A"} | <strong>Job Title:</strong> {pendingRecallRecord.Title || "N/A"}
                      </div>
                      <div className="mt-3">
                        <label className="form-label text-secondary small fw-bold mb-1">
                          Remarks <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Enter remarks / details requested..."
                          value={recallRemarks}
                          onChange={(e) => setRecallRemarks(e.target.value)}
                          style={{ fontSize: '13px' }}
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* Footer */}
                <div className="modal-footer border-top-0 bg-light p-3 px-4 d-flex justify-content-end gap-2">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary btn-sm px-4 rounded-pill fw-medium" 
                    onClick={() => {
                      setShowRecallModal(false);
                      setPendingRecallRecord(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-danger btn-sm px-4 rounded-pill fw-semibold text-white shadow-sm d-inline-flex align-items-center"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      )}

      {isAssignLoading && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
          style={{ zIndex: 1060 }}
        >
          <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <span className="mt-3 fw-bold text-dark">Fetching Allocation Details...</span>
        </div>
      )}
    </>
  );
}
export default PostJob;


